export const FIELDS: {name: string, label: string, type?: string}[] = [
  { name: 'bidderKey', label: 'Bidder Key' },
  { name: 'appId', label: 'App ID' },
  { name: 'partnerId', label: 'Partner ID' },
  { name: 'publisherId', label: 'Publisher ID' },
  { name: 'placementId', label: 'Placement ID' },
  { name: 'placement', label: 'Placement' },
  { name: 'seatId', label: 'Seat ID' },
  { name: 'nurlEncKey', label: 'Nurl Enc Key' },
  { name: 'siteId', label: 'Site ID' },
  { name: 'site_id', label: 'Site ID' },
  { name: 'tagId', label: 'Ad Unit ID' },
  { name: 'tagid', label: 'Tag ID' },
  { name: 'memberid', label: 'Member ID' },
  { name: 'site', label: 'Site' },
  { name: 'schainStr', label: 'Supply Chain' },
  { name: 'impId', label: 'Imp ID' },
  { name: 'syncUrl', label: 'Sync URL' },
  { name: 'syncId', label: 'Sync ID' },
  { name: 'authorization', label: 'Authorization' },
  { name: 'zone_id', label: 'Zone ID' },
  { name: 'account_id', label: 'Account ID' },
  { name: 'size_id', label: 'Size ID' },
  { name: 'displaymanager', label: 'Display Manager' },
  { name: 'displaymanagerver', label: 'Display Manager Version' },
  { name: 'callerId', label: 'Caller ID' },
  { name: 'appBundle', label: 'App Bundle' },
  { name: 'cookie_sync_id', label: 'Cookie Sync ID' },
  { name: 'pid', label: 'PID' },
  { name: 'placement_type', label: 'Placement Type' },
  { name: 'cid', label: 'Connection ID' },
  { name: 'pubId', label: 'Publisher ID' },
  { name: 'plcmt', label: 'PLCMT' , type: 'number' },
  { name: 'adspaceId', label: 'Ad Space ID' },
  { name: 'network_id', label: 'Network ID' },
  { name: 'sectionId', label: 'Site section ID' },
  { name: 'profile_id', label: 'Profile ID' },
  { name: 'prefix', label: 'Prefix' },
  { name: 'zoneId', label: 'Zone ID' },
  { name: 'domain', label: 'Domain' },
  { name: 'organizationId', label: 'Organization ID' },
  { name: 'pagetype', label: 'Page Type' },
  { name: 'category', label: 'Category' },
];

const COMMON_AVAILABLE_FOR_SONOBI =  [
  {
    name: 'partnerId',
    ignoreAssignment: true,
    replaceIn: {
      path: 'endpoint',
      param: 'partner_id',
    },
    readFrom: {
      path: 'endpoint',
      param: 'partner_id',
    },
  },
  'tagid',
];

export const RTB_PROVIDERS = [
  {
    id: 1,
    name: 'Improve Digital',
    endpointMatcher: '360yield',
    web: {
      disabled: true,
      available: [
        'nurlEncKey',
        'partnerId',
        'publisherId',
        { name: 'placementId', path: 'siteConfig[0].placementId' },
        { name: 'siteId', path: 'siteConfig[0].siteId' },
        { name: 'site', path: 'siteConfig[0].site' },
      ],
      required: ['nurlEncKey', 'partnerId', 'publisherId', 'placementId', 'siteId', 'site'],
      config: {
        bidderKey: 'improvedigital',
        bidderAbbr: 'IMP',
        interop: {
          rtb_request_pass_height: false,
          rtb_request_pass_width: false,
        },
        nurlEncKey: 'XXXXXX',
        partnerId: 'XXXX',
        publisherId: 'XXXX',
        schain: {
          asi: 'cedato.com',
        },
        siteConfig: [
          {
            impId: '1',
            placementId: 'XXXXXX',
            site: 'XXXXXX.com',
            siteId: 'XXXXXX',
          },
        ],
        supportUserSync: true,
        syncCallbackType: 'iframe',
        syncUrl:
          'https://ad.360yield.com/server_match?partner_id=[PARTNER_ID]&r=https://rtb.[SERV_DOMAIN]/cookie_sync?bid=[BIDDER_ID]&srv=[SERV_DOMAIN]&cuid=[CEDATO_USER_ID]&uid={PUB_USER_ID}',
        timeout: 180,
      },
    },
    inApp: {
      available: ['appId', 'partnerId', 'placementId', 'schainStr'],
      required: ['appId', 'partnerId', 'placementId'],
      config: {
        bidderKey: 'improvedigital',
        appId: 'XXXXXX',
        countryFormat: '2L',
        interop: {
          rtb_request_pass_height: false,
          rtb_request_pass_width: false,
        },
        partnerId: 'XXXX',
        placementId: 'XXXXXXXX',
        schainStr: '',
      },
    },
  },
  {
    id: 2,
    name: 'Pubmatic',
    endpointMatcher: 'pubmatic',
    web: {
      available: [
        'nurlEncKey',
        'tagid',
        {
          name: 'cookie_sync_id',
          ignoreAssignment: true, // ignore assignment into JSON
          replaceIn: {
            path: 'syncUrl',
            value:
              '[SCHEME]://ads.pubmatic.com/AdServer/js/user_sync.html?p=[cookie_sync_id]&userIdMacro=PM_UID&predirect=[SCHEME]%3A%2F%2Frtb.[SERV_DOMAIN]%2Fcookie_sync%3Fbid%3D[BIDDER_ID]%26srv%3D[SERV_DOMAIN]%26cuid%3D[CEDATO_USER_ID]%26uid%3DPM_UID',
          },
          readFrom: {
            path: 'syncUrl',
            pattern: 'p=([^&]*)',
          },
        },
      ],
      required: ['nurlEncKey', 'tagid', 'cookie_sync_id'],
      config: {
        bidderKey: 'pubmatic',
        bidderAbbr: 'PU',
        bidderType: 'PubmaticRTB',
        bidder_eid_type: 'pubmatic.com',
        nurlEncKey: 'XXXXXX',
        supportUserSync: true,
        syncCallbackType: 'iframe',
        syncUrl:
          '[SCHEME]://ads.pubmatic.com/AdServer/js/user_sync.html?p=XXXXXX&userIdMacro=PM_UID&predirect=[SCHEME]%3A%2F%2Frtb.[SERV_DOMAIN]%2Fcookie_sync%3Fbid%3D[BIDDER_ID]%26srv%3D[SERV_DOMAIN]%26cuid%3D[CEDATO_USER_ID]%26uid%3DPM_UID',
        tagid: 'XXXXXX',
      },
    },
    inApp: {
      available: ['publisherId', 'tagid', 'schainStr'],
      required: ['publisherId', 'tagid'],
      config: {
        bidderKey: 'pubmatic',
        publisherId: 'XXXXXX',
        tagid: 'XXXXXX',
        schainStr: '',
      },
    },
    admin: {
      config: {
        maxbitrate: 15000,
        minbitrate: 1
      }
    }
  },
  // id: 3 was Pubmatic (Schain)
  {
    id: 4,
    name: 'Synacor / Technoratimedia',
    endpointMatcher: 'technoratimedia',
    web: {
      available: [
        'nurlEncKey',
        'tagid',
        {
          name: 'pid',
          ignoreAssignment: true, // ignore assignment into JSON
          replaceIn: {
            path: 'syncUrl',
            value:
              '[SCHEME]://sync.technoratimedia.com/services?srv=cs&pid=[pid]&uid=[CEDATO_USER_ID]&cb=[SCHEME]%3A%2F%2Frtb.[SERV_DOMAIN]%2Fcookie_sync%3Fbid%3D[BIDDER_ID]%26srv%3D[SERV_DOMAIN]%26cuid%3D[CEDATO_USER_ID]%26uid%3D%5BUSER_ID%5D',
          },
          readFrom: {
            path: 'syncUrl',
            pattern: 'pid=([^&]*)',
          },
        },
      ],
      required: ['nurlEncKey', 'tagid', 'pid'],
      config: {
        bidderKey: 'synacor',
        bidderAbbr: 'TRM',
        bidderToVast: false,
        bidderType: 'Synacor',
        nurlEncKey: 'XXXXXX',
        supportUserSync: true,
        syncCallbackType: 'image',
        syncUrl:
          '[SCHEME]://sync.technoratimedia.com/services?srv=cs&pid=XXXXXX&uid=[CEDATO_USER_ID]&cb=[SCHEME]%3A%2F%2Frtb.[SERV_DOMAIN]%2Fcookie_sync%3Fbid%3D[BIDDER_ID]%26srv%3D[SERV_DOMAIN]%26cuid%3D[CEDATO_USER_ID]%26uid%3D%5BUSER_ID%5D',
        tagid: 'XXXXXX',
        timeout: 360,
      },
    },
    inApp: {
      available: [
        'tagid',
        'schainStr',
        {
          name: 'pid',
          ignoreAssignment: true, // ignore assignment into JSON
          replaceIn: {
            path: 'syncUrl',
            value:
              '[SCHEME]://sync.technoratimedia.com/services?srv=cs&pid=[pid]&uid=[CEDATO_USER_ID]&cb=[SCHEME]%3A%2F%2Frtb.[SERV_DOMAIN]%2Fcookie_sync%3Fbid%3D[BIDDER_ID]%26srv%3D[SERV_DOMAIN]%26cuid%3D[CEDATO_USER_ID]%26uid%3D%5BUSER_ID%5D',
          },
          readFrom: {
            path: 'syncUrl',
            pattern: 'pid=([^&]*)',
          },
        },
      ],
      required: ['tagid', 'pid'],
      config: {
        bidderKey: 'synacor',
        bidderAbbr: 'TRM',
        bidderType: 'Technoratimedia',
        cookieSyncTTL: 60,
        supportUserSync: true,
        syncCallbackType: 'image',
        syncUrl:
          '[SCHEME]://sync.technoratimedia.com/services?srv=cs&pid=XXXXXX&uid=[CEDATO_USER_ID]&cb=[SCHEME]%3A%2F%2Frtb.[SERV_DOMAIN]%2Fcookie_sync%3Fbid%3D[BIDDER_ID]%26srv%3D[SERV_DOMAIN]%26cuid%3D[CEDATO_USER_ID]%26uid%3D%5BUSER_ID%5D',
        tagid: 'XXXXX',
        schainStr: '',
      },
    },
  },
  {
    id: 5,
    name: 'Inmobi',
    endpointMatcher: 'inmobi',
    web: {
      available: ['bidderKey'],
      config: {
        bidderKey: 'inmobi',
      },
    },
    inApp: {
      available: ['tagid', 'schainStr'],
      required: ['tagid', 'schainStr'],
      config: {
        bidderKey: 'inmobi',
        tagid: 'XXXXXX',
        schainStr: 'XXXXXX',
      },
    },
  },
  {
    id: 6,
    name: 'Xandr / Appnexus',
    endpointMatcher: 'adnxs',
    web: {
      available: ['bidderKey'],
      config: {
        bidderKey: 'appnexus',
      },
    },
    inApp: {
      available: [
        // { name: 'memberid', path: 'extensions.req.appnexus.seller_member_id' },
        'publisherId',
        'tagid',
        'schainStr',
      ],
      required: [
        // 'memberid',
        'tagid',
      ],
      config: {
        bidderKey: 'appnexus',
        // memberid: "XXXXXX",
        tagid: 'XXXXXX',
        schainStr: '',
        publisherId: 'XXXXXX',
        // extensions: {
        //   req: {
        //     appnexus: {
        //       seller_member_id: 'XXXXXX',
        //     },
        //   },
        // },
      },
    },
  },
  {
    id: 7,
    name: 'Yahoo',
    web: {
      available: ['tagid', 'siteId', 'syncUrl'],
      required: ['tagid', 'siteId', 'syncUrl'],
      config: {
        bidderKey: 'yahoo',
        bidderAbbr: 'YAHOO',
        bidderType: 'Yahoo',
        bidder_eid_type: 'yahoo.com',
        cookieSyncTTL: 15,
        eids_feature: 1,
        siteId: 'XXXXXX',
        supportUserSync: true,
        syncCallbackType: 'image',
        syncUrl: '[SCHEME]://ups.analytics.yahoo.com/ups/XXXXXX/occ?uid=[CEDATO_USER_ID]',
        tagid: 'XXXXXX',
      },
    },
    inApp: {
      available: ['tagid', 'schainStr', 'appId', 'publisherId', { name: 'appBundle', permissions: 'admin' }],
      required: ['tagid', 'appId', 'publisherId'],
      config: {
        bidderKey: 'yahoo',
        appId: 'XXXXXX',
        publisherId: 'XXXXX',
        tagid: 'XXXXXX',
        schainStr: '',
      },
    },
  },
  {
    id: 8,
    name: 'Rubicon',
    endpointMatcher: 'rubiconproject',
    web: {
      available: [
        { name: 'authorization'},
        { name: 'zone_id', path: 'extensions.imp.rp.zone_id' },
        { name: 'site_id', path: 'extensions.site.rp.site_id' },
        { name: 'account_id', path: 'extensions.[\'site.publisher\'].rp.account_id' },
        {
          name: 'syncId',
          ignoreAssignment: true, // ignore assignment into JSON
          readFrom: {
            path: 'syncUrl',
            pattern: 'p=([^&]*)',
          },
          replaceIn: {
            path: 'syncUrl',
            value: '[SCHEME]://secure-assets.rubiconproject.com/utils/xapi/multi-sync.html?p=[syncId]&endpoint=us-east',
          },
        },
      ],
      required: ['authorization', 'siteId', 'account_id', 'syncId'],
      config: {
        bidderKey: 'rubicon',
        authorization: 'Basic XXXXX',
        bidderAbbr: 'MAGNITE',
        bidderType: 'Magnite',
        bidder_eid_type: 'rubiconproject.com',
        cookieSyncTTL: 15,
        extensions: {
          imp: {
            rp: {
              zone_id: 'XXXXXX',
            },
          },
          site: {
            rp: {
              site_id: 'XXXXXX',
            },
          },
          'site.publisher': {
            rp: {
              account_id: 'XXXXXX',
            },
          },
        },
        supportUserSync: true,
        syncCallbackType: 'iframe',
        syncUrl:
          '[SCHEME]://secure-assets.rubiconproject.com/utils/xapi/multi-sync.html?p=[account_id]&endpoint=us-east',
      },
    },
    inApp: {
      available: [
        'schainStr',
        { name: 'authorization', },
        { name: 'zone_id', path: 'extensions.imp.rp.zone_id' },
        { name: 'site_id', path: 'extensions.app.rp.site_id' },
        {
          name: 'account_id',
          path: 'extensions.[\'app.publisher\'].rp.account_id',
        },
        { name: 'size_id', path: 'extensions.[\'imp.video\'].rp.size_id' },
      ],
      required: ['authorization', 'site_id', 'account_id', 'size_id'],
      config: {
        bidderKey: 'rubicon',
        schainStr: '',
        authorization: 'Basic XXXXX',
        bidderAbbr: 'MAGNITE',
        bidderType: 'Magnite',
        bidder_eid_type: 'rubiconproject.com',
        extensions: {
          imp: {
            rp: {
              zone_id: 'XXXXXX',
            },
          },
          'imp.video': {
            rp: {
              size_id: 'XXXXXX',
            },
          },
          app: {
            rp: {
              site_id: 'XXXXXX',
            },
          },
          'app.publisher': {
            rp: {
              account_id: 'XXXXXX',
            },
          },
        },
      },
    },
  },
  {
    id: 9,
    name: 'Conversant',
    endpointMatcher: 'dotomi',
    web: {
      available: ['bidderKey'],
      config: {
        bidderKey: 'conversant',
      },
    },
    inApp: {
      available: [
        'appId',
        'displaymanager',
        'displaymanagerver',
        'schainStr',
        'tagid',
        { name: 'appBundle', permissions: 'admin' },
      ],
      required: ['appId', 'schainStr', 'tagid'],
      config: {
        bidderKey: 'conversant',
        appId: 'XXXX',
        displaymanager: '',
        displaymanagerver: '',
        tagid: 'XXXXX',
        schainStr: 'X.X,X!xxxx,XXXX,X',
      },
    },
  },
  {
    id: 10,
    name: 'Loop Me',
    endpointMatcher: 'loopmertb',
    web: {
      available: ['bidderKey'],
      config: {
        bidderKey: 'loopme',
      },
    },
    inApp: {
      available: ['publisherId', 'schainStr'],
      required: ['publisherId', 'schainStr'],
      config: {
        bidderKey: 'loopme',
        publisherId: 'XXXXXX',
        schainStr: 'XXXXXX',
      },
    },
  },
  {
    id: 11,
    name: 'Index Exchange',
    web: {
      available: [
        {
          name: 'cookie_sync_id',
          ignoreAssignment: true, // ignore assignment into JSON
          replaceIn: {
            path: 'syncUrl',
            value:
              '[SCHEME]://ssum-sec.casalemedia.com/usermatch?s=[cookie_sync_id]&cb=[SCHEME]%3A%2F%2Frtb.[SERV_DOMAIN]%2Fcookie_sync%3Fbid%3D[BIDDER_ID]%26srv%3D[SERV_DOMAIN]%26cuid%3D[CEDATO_USER_ID]%26uid%3D',
          },
          readFrom: {
            path: 'syncUrl',
            pattern: 's=([^&]*)',
          },
        },
      ],
      required: ['cookie_sync_id'],
      config: {
        bidderKey: 'ix',
        bidderAbbr: 'IDXEXCHNG',
        bidderType: 'IndexExchange',
        bidder_eid_type: 'indexexchange.com',
        cookieSyncTTL: 15,
        eids_feature: 1,
        supportUserSync: true,
        syncCallbackType: 'iframe',
        syncUrl:
          '[SCHEME]://ssum-sec.casalemedia.com/usermatch?s=XXXXXX&cb=[SCHEME]%3A%2F%2Frtb.[SERV_DOMAIN]%2Fcookie_sync%3Fbid%3D[BIDDER_ID]%26srv%3D[SERV_DOMAIN]%26cuid%3D[CEDATO_USER_ID]%26uid%3D',
      },
    },
    inApp: {
      available: ['schainStr'],
      config: {
        bidderKey: 'ix',
        schainStr: '',
      },
    },
  },
  {
    id: 12,
    name: 'Smart AdServer',
    endpointMatcher: 'smartadserver',
    web: {
      available: [
        {
          name: 'cookie_sync_id',
          ignoreAssignment: true, // ignore assignment into JSON
          replaceIn: {
            path: 'syncUrl',
            value: 'https://ssbsync.smartadserver.com/api/sync?callerId=[cookie_sync_id]',
          },
          readFrom: {
            path: 'syncUrl',
            pattern: 'callerId=([^&]*)',
          },
        },
      ],
      required: ['cookie_sync_id'],
      config: {
        bidderKey: 'smartadserver',
        bidderAbbr: 'EXSMRT',
        bidderType: 'Smart',
        bidder_eid_type: 'smartadserver.com',
        cookieSyncTTL: 15,
        supportUserSync: true,
        syncCallbackType: 'iframe',
        syncUrl: 'https://ssbsync.smartadserver.com/api/sync?callerId=XXXXXX',
      },
    },
    inApp: {
      available: ['publisherId', 'schainStr'],
      required: ['publisherId'],
      config: {
        bidderKey: 'smartadserver',
        publisherId: 'XXXXXX',
        schainStr: '',
      },
    },
  },
  {
    id: 13,
    name: 'Sovrn',
    web: {
      available: ['tagid', 'publisherId'],
      required: ['tagid', 'publisherId'],
      config: {
        bidderKey: 'sovrn',
        bidderAbbr: 'SVRN',
        bidderToVast: false,
        bidderType: 'Sovrn',
        bidder_eid_type: 'sovrn.com',
        buyeruidRequired: true,
        cookieSyncTTL: 60,
        eids_feature: 1,
        publisherId: 'XXXX',
        supportUserSync: true,
        syncCallbackType: 'image',
        syncUrl:
          '[SCHEME]://ap.lijit.com/pixel?gdpr=[GDPR]&gdpr_consent=[GDPR_CONSENT]&redir=https%3A%2F%2Frtb.[SERV_DOMAIN].com%2Fcookie_sync%3Fbid%3D8197%26srv%3D[SERV_DOMAIN]%26cuid%3D[CEDATO_USER_ID]%26uid%3D%24UID',
        tagid: 'XXXX',
        timeout: 360,
      },
    },
    inApp: {
      available: ['schainStr'],
      config: {
        bidderKey: 'sovrn',
        schainStr: '',
      },
    },
  },

  {
    id: 14,
    name: 'OpenX',
    web: {
      available: ['publisherId', 'siteId', 'tagId'],
      config: {
        bidderKey: 'openx',
        bidderAbbr: 'OPENX',
        bidderType: 'OpenX',
        bidder_eid_type: 'openx.com',
        supportUserSync: true,
        syncCallbackType: 'image',
      },
    },
    inApp: {
      available: ['publisherId', 'siteId', 'tagId'],
      config: {
        bidderKey: 'openx',
        bidderAbbr: 'OPENX',
        bidderType: 'OpenX',
        bidder_eid_type: 'openx.com',
        supportUserSync: true,
        syncCallbackType: 'image',
      },
    },
  },
  {
    id: 15,
    name: 'Unruly',
    web: {
      available: ['bidderKey'],
      config: {
        bidderKey: 'unruly',
      },
    },
    inApp: {
      available: ['placementId', 'schainStr'],
      required: ['placementId'],
      config: {
        bidderKey: 'unruly',
        placementId: 'XXXXXX',
        schainStr: '',
      },
    },
  },
  {
    id: 16,
    name: 'TripleLift',
    endpointMatcher: '3lift',
    web: {
      available: ['tagid'],
      required: ['tagid'],
      config: {
        bidderKey: 'tripleLift',
        bidderAbbr: '3lift',
        bidderType: '3lift',
        bidder_eid_type: 'triplelift.com',
        supportUserSync: true,
        syncCallbackType: 'image',
        syncUrl:
          '[SCHEME]://eb2.3lift.com/getuid?redir=[SCHEME]%3A%2F%2Frtb.[SERV_DOMAIN]%2Fcookie_sync%3Fbid%3D[BIDDER_ID]%26srv%3D[SERV_DOMAIN]%26cuid%3D[CEDATO_USER_ID]%26uid%3D$UID',
        tagid: 'XXXXXX',
      },
    },
    inApp: {
      available: ['schainStr'],
      config: {
        bidderKey: 'tripleLift',
        schainStr: '',
      },
    },
  },
  {
    id: 17,
    name: 'Sharethrough',
    endpointMatcher: 'sharethrough',
    web: {
      available: ['bidderKey'],
      config: {
        bidderKey: 'sharethrough',
      },
    },
    inApp: {
      available: ['publisherId', 'schainStr'],
      required: ['publisherId'],
      config: {
        bidderKey: 'sharethrough',
        publisherId: 'XXXXXX',
        schainStr: '',
      },
    },
  },
  {
    id: 18,
    name: 'Sunday Sky',
    endpointMatcher: 'sundaysky',
    web: {
      available: ['bidderKey'],
      config: {
        bidderKey: 'sundaysky',
      },
    },
    inApp: {
      available: ['schainStr'],
      config: {
        bidderKey: 'sundaysky',
        schainStr: '',
      },
    },
  },
  {
    id: 19,
    name: 'Bidswitch',
    endpointMatcher: 'bidswitch',
    web: {
      available: ['bidderKey'],
      config: {
        bidderKey: 'bidswitch',
      },
    },
    inApp: {
      available: ['schainStr'],
      config: {
        bidderKey: 'bidswitch',
        schainStr: '',
      },
    },
  },
  {
    id: 20,
    endpointReadonly: true,
    name: 'Rise',
    endpointMatcher: 'yellowblue',
    web: {
      replaceEndpoint: true,
      endpoint: 'https://s2s.yellowblue.io/rtb?publisher_id={{publisher_id}}',
      available: [
        {
          name: 'publisherId',
          ignoreAssignment: true, // ignore assignment into JSON
          replaceIn: {
            path: 'endpoint',
            param: 'publisher_id',
          },
          readFrom: {
            path: 'endpoint',
            param: 'publisher_id',
          },
        },
        {
          name: 'placementId',
          ignoreAssignment: true,
          replaceIn: {
            path: 'endpoint',
            param: 'placement_id',
          },
          readFrom: {
            path: 'endpoint',
            param: 'placement_id',
          },
        },
      ],
      required: ['publisherId'],
      config: {
        bidderKey: 'rise',
        exco: {
          syncUrl: 'https://cs-server-s2s.yellowblue.io/sync-iframe?gdpr=[GDPR]&gdpr_consent=[GDPR_CONSENT]&redirect=[EXCO_CB]',
          usermacro: '{partnerId}',
          supportUserSync: true,
          syncCallbackType: 'iframe',
        },
      },
    },
    inApp: {
      replaceEndpoint: true,
      endpoint: 'https://inapp-rtb.yellowblue.io/rtb?publisher_id={{publisher_id}}',
      available: [
        {
          name: 'publisherId',
          ignoreAssignment: true,
          replaceIn: {
            path: 'endpoint',
            param: 'publisher_id',
          },
          readFrom: {
            path: 'endpoint',
            param: 'publisher_id',
          },
        },
        {
          name: 'placementId',
          ignoreAssignment: true,
          replaceIn: {
            path: 'endpoint',
            param: 'placement_id',
          },
          readFrom: {
            path: 'endpoint',
            param: 'placement_id',
          },
        },
      ],
      required: ['publisherId'],
      config: {
        bidderKey: 'rise',
      },
    },
  },
  {
    id: 21,
    name: '33 Across',
    endpointMatcher: '33across',
    web: {
      endpoint: 'https://ssc.33across.com/api/v1/s2s',
      available: [
        'siteId',
        {name: 'zone_id', path: 'extensions.imp.ext.ttx.zoneid'},
        {
          name: 'placement_type',
          path: 'extensions.imp.ext.ttx.prod',
          options: [
            {
              name: 'out-stream',
              value: 'siab',
            },
            {
              name: 'in-stream',
              value: 'instream',
            }
          ]
        },
      ],
      required: ['zone_id', 'placement_type', 'siteId'],
      config: {
        bidderKey: '33across',
        siteId: '',
      },
    },
    inApp: {
      endpoint: 'https://ssc.33across.com/api/v1/s2s',
      available: [
        'appId',
        {name: 'zone_id', path: 'extensions.imp.ext.ttx.zoneid'},
        {
          name: 'placement_type',
          path: 'extensions.imp.ext.ttx.prod',
          options: [
            {
              name: 'out-stream',
              value: 'siab',
            },
            {
              name: 'in-stream',
              value: 'instream',
            }
          ]
        },
      ],
      required: ['zone_id', 'placement_type', 'appId'],
      config: {
        bidderKey: '33across',
        appId: '',
      },
    },
  },
  {
    id: 22,
    name: 'Eskimi',
    web: {
      config: {
        bidderKey: 'eskimi',
      },
    },
    inApp: {
      config: {
        bidderKey: 'eskimi',
      },
    },
  },
  {
    id: 23,
    name: 'Rich Audience',
    web: {
      available: ['tagid', 'siteId', 'appId'],
      required: ['tagid'],
      config: {
        bidderKey: 'richaudience',
      },
    },
    inApp: {
      available: ['tagid', 'siteId', 'appId'],
      required: ['tagid'],
      config: {
        bidderKey: 'richaudience',
      },
    },
  },
  {
    id: 24,
    name: 'Gum Gum',
    web: {
      replaceEndpoint: true,
      endpoint: 'https://g2.gumgum.com/publishers/{{pub_id}}/bid',
      available: [
        {
          name: 'publisherId',
          replaceIn: {
            path: 'endpoint',
            pathAttribute: '{{pub_id}}'
          },
          readFrom: {
            path: 'publisherId',
          },
        },
        'displaymanager',
        'displaymanagerver'
      ],
      required: ['publisherId'],
      config: {
        bidderKey: 'gumgum',
      },
    },
    inApp: {
      replaceEndpoint: true,
      endpoint: 'https://g2.gumgum.com/publishers/{{pub_id}}/bid',
      available: [
        {
          name: 'publisherId',
          replaceIn: {
            path: 'endpoint',
            pathAttribute: '{{pub_id}}'
          },
          readFrom: {
            path: 'publisherId',
          },
        },
        'displaymanager',
        'displaymanagerver'
      ],
      required: ['publisherId'],
      config: {
        bidderKey: 'gumgum',
      },
    },
  },
  {
    id: 25,
    endpointReadonly: true,
    name: 'Sonobi',
    endpointMatcher: 'sonobi',
    web: {
      replaceEndpoint: true,
      endpoint: 'http://useast-demand.go.sonobi.com/bid?partner_id={{partner_id}}',
      available: COMMON_AVAILABLE_FOR_SONOBI,
      required: ['partnerId', 'tagid'],
      config: {
        bidderKey: 'sonobi',
        environment: 1,
        exco: {
          syncUrl: 'https://sync.go.sonobi.com/us?[EXCO_CB]',
          usermacro: '[UID]',
          supportUserSync: true,
          syncCallbackType: 'iframe',
        },
      },
    },
    inApp: {
      replaceEndpoint: true,
      endpoint: 'http://useast-demand.go.sonobi.com/bid?partner_id={{partner_id}}',
      available: COMMON_AVAILABLE_FOR_SONOBI,
      required: ['partnerId', 'tagid'],
      config: {
        bidderKey: 'sonobi',
        environment: 1,
        exco: {
          syncUrl: 'https://sync.go.sonobi.com/us?[EXCO_CB]',
          usermacro: '[UID]',
          supportUserSync: true,
          syncCallbackType: 'iframe',
        },
      },
    },
  },
  {
    id: 26,
    endpointReadonly: true,
    name: 'Kueez',
    endpointMatcher: 'kueez',
    web: {
      replaceEndpoint: true,
      endpoint: 'https://exchange.kueezrtb.com/openrtb/{{CID}}',
      available: [
        {
          name: 'cid',
          replaceIn: {
            path: 'endpoint',
            pathAttribute: '{{CID}}'
          },
          readFrom: {
            path: 'cid',
          },
        }
      ],
      required: ['cid'],
      config: {
        bidderKey: 'kueez',
        supportUserSync: true,
        syncCallbackType: 'iframe',
        syncUrl: ' https://sync.kueezrtb.com/api/user/html/62ce79e7dd15099534ae5e04?redirect=[EXCO_CB]%24%7BuserId%7D&gdpr=[GDPR]&gdpr_consent=[GDPR_CONSENT]',
      },
    },
    inApp: {
      replaceEndpoint: true,
      endpoint: 'https://exchange.kueezrtb.com/openrtb/{{CID}}',
      available: [
        {
          name: 'cid',
          replaceIn: {
            path: 'endpoint',
            pathAttribute: '{{CID}}'
          },
          readFrom: {
            path: 'cid',
          },
        }
      ],
      required: ['cid'],
      config: {
        bidderKey: 'kueez',
        supportUserSync: true,
        syncCallbackType: 'iframe',
        syncUrl: ' https://sync.kueezrtb.com/api/user/html/62ce79e7dd15099534ae5e04?redirect=[EXCO_CB]%24%7BuserId%7D&gdpr=[GDPR]&gdpr_consent=[GDPR_CONSENT]',
      },
    },
  },
  {
    id: 27,
    name: 'OneTag',
    endpointMatcher: 'onetag',
    web: {
      available: ['pubId', 'plcmt', 'schainStr'],
      required: ['pubId'],
      config: {
        bidderKey: 'onetag'
      },
    },
    inApp: {
      available: ['pubId', 'plcmt', 'schainStr'],
      required: ['pubId'],
      config: {
        bidderKey: 'onetag'
      },
    },
  },
  {
    id: 28,
    name: 'Smaato',
    endpointMatcher: 'smaato',
    web: {
      available: ['publisherId', 'adspaceId', 'plcmt', 'schainStr'],
      required: ['publisherId'],
      config: {
        bidderKey: 'smaato',
      },
    },
    inApp: {
      available: ['publisherId', 'adspaceId', 'plcmt', 'schainStr'],
      required: ['publisherId'],
      config: {
        bidderKey: 'smaato',
      },
    },
  },
  {
    id: 0,
    name: 'Other',
    web: {
      config: {},
    },
    inApp: {
      available: ['schainStr'],
      config: {
        schainStr: '',
      },
    },
  },

  {
    id: 30,
    endpointReadonly: true,
    name: 'Copper6',
    endpointMatcher: 'copper6',
    web: {
      replaceEndpoint: true,
      endpoint: 'http://endpoint.copper6.com/?c=rtb&m=req&key=64',
      config: {
        bidderKey: 'copper6',
        supportUserSync: true,
        syncCallbackType: 'iframe',
        syncUrl: 'https://csync.copper6.com/9047d5fb72272a54346c148f402a8f92.gif?puid=[UID]&redir=[RED]&gdpr=[GDPR]&gdpr_consent=[GDPR_CONSENT]&coppa=[COPPA]&gpp=[GPP]&gpp_sid=[GPP_SID]',
      },
    },
    inApp: {
      replaceEndpoint: true,
      endpoint: 'http://endpoint.copper6.com/?c=rtb&m=req&key=64',
      config: {
        bidderKey: 'copper6',
        supportUserSync: true,
        syncCallbackType: 'iframe',
        syncUrl: 'https://csync.copper6.com/9047d5fb72272a54346c148f402a8f92.gif?puid=[UID]&redir=[RED]&gdpr=[GDPR]&gdpr_consent=[GDPR_CONSENT]&coppa=[COPPA]&gpp=[GPP]&gpp_sid=[GPP_SID]',
      },
    },
  },
  {
    id: 31,
    name: 'Adform',
    endpointMatcher: 'adform',
    web: {
      available: ['tagid', 'plcmt', 'schainStr', 'placement'],
      endpoint: 'https://adx.adform.net/adx/openrtb',
      replaceEndpoint: true,
      required: ['tagid'],
      config: {
        bidderKey: 'adform',
      },
    },
    inApp: {
      available: ['tagid', 'plcmt', 'schainStr', 'placement'],
      endpoint: 'https://adx.adform.net/adx/openrtb',
      replaceEndpoint: true,
      required: ['tagid'],
      config: {
        bidderKey: 'adform',
      },
    },
  },
  {
    id: 29,
    name: 'Freewheel MRM',
    endpointMatcher: 'fwmrm',
    web: {
      replaceEndpoint: true,
      endpoint: 'https://{{prefix}}.v.fwmrm.net/ortb/ssp',
      available: [
        {
          name: 'prefix',
          replaceIn: {
            path: 'endpoint',
            pathAttribute: '{{prefix}}'
          },
          readFrom: {
            path: 'prefix',
          },
        },
        { name: 'network_id', path: 'publisherId' },
        { name: 'sectionId', path: 'siteId' },
        { name: 'profile_id', path: 'extensions.imp.profile_id' }],
      required: ['prefix', 'network_id', 'sectionId', 'profile_id'],
      config: {
        bidderKey: 'freewheel_mrm',
        extensions: {
          imp: {
            profile_id: ''
          }
        }
      },
    },
    inApp: {
      available: [
        {
          name: 'prefix',
          replaceIn: {
            path: 'endpoint',
            pathAttribute: '{{prefix}}'
          },
          readFrom: {
            path: 'prefix',
          },
        },
        { name: 'network_id', path: 'publisherId' },
        { name: 'sectionId', path: 'siteId' },
        { name: 'profile_id', path: 'extensions.imp.profile_id' }],
      required: ['prefix', 'network_id', 'sectionId', 'profile_id'],
      replaceEndpoint: true,
      endpoint: 'https://{{prefix}}.v.fwmrm.net/ortb/ssp',
      config: {
        bidderKey: 'freewheel_mrm',
        extensions: {
          imp: {
            profile_id: ''
          }
        }
      },
    },
  },
  {
    id: 32,
    name: 'Freewheel',
    endpointMatcher: 'freewheel',
    web: {
      replaceEndpoint: true,
      available: [
        { name: 'siteId', path: 'extensions.imp.siteId' },
        { name: 'zoneId', path: 'extensions.imp.zoneId' }],
      required: ['zoneId', 'siteId'],
      endpoint: 'https://2fc2.ads.stickyadstv.com/openrtb/dsp',
      config: {
        bidderKey: 'freewheel',
        bidderAbbr: 'FW',
        bidderType: 'Freewheel',
        exco: {
          syncUrl: '[SCHEME]://ads.stickyadstv.com/user-matching?id=3684&gdpr=[GDPR]&gdpr_consent=[GDPR_CONSENT]&gpp=[GPP]&gpp_sid=[GPP_SID]'
        },
        extensions: {
          imp: {
            zoneId: '',
            siteId: '',
          },
        },
      }},
    inApp: {
      replaceEndpoint: true,
      endpoint: 'https://2fc2.ads.stickyadstv.com/openrtb/dsp',
      available: [
        { name: 'siteId', path: 'extensions.imp.siteId' },
        { name: 'zoneId', path: 'extensions.imp.zoneId' }],
      required: ['zoneId', 'siteId'],
      config: {
        bidderKey: 'freewheel',
        bidderAbbr: 'FW',
        bidderType: 'Freewheel',
        exco: {
          syncUrl: '[SCHEME]://ads.stickyadstv.com/user-matching?id=3684&gdpr=[GDPR]&gdpr_consent=[GDPR_CONSENT]&gpp=[GPP]&gpp_sid=[GPP_SID]'
        },
        extensions: {
          imp: {
            zoneId: '',
            siteId: '',
          },
        },
      }},
  },
  {
    id: 33,
    endpointReadonly: true,
    name: 'League M',
    endpointMatcher: 'league-m',
    web: {
      replaceEndpoint: true,
      endpoint: 'https://rtb.league-m.media/?pid={{pid}}',
      available: [
        {
          name: 'pid',
          ignoreAssignment: true,
          replaceIn: {
            path: 'endpoint',
            param: 'pid',
          },
          readFrom: {
            path: 'endpoint',
            param: 'pid',
          },
        },
      ],
      required: ['pid'],
      config: {
        bidderKey: 'leaguem',
      },
    },
    inApp: {
      replaceEndpoint: true,
      endpoint: 'https://rtb.league-m.media/?pid={{pid}}',
      available: [
        {
          name: 'pid',
          ignoreAssignment: true,
          replaceIn: {
            path: 'endpoint',
            param: 'pid',
          },
          readFrom: {
            path: 'endpoint',
            param: 'pid',
          },
        },
      ],
      required: ['pid'],
      config: {
        bidderKey: 'leaguem',
      },
    },
  },
  {
    id: 34,
    endpointReadonly: true,
    name: 'Yahoo DSP',
    inApp: {
      replaceEndpoint: true,
      endpoint: 'https://{{yahoo_domain}}/dtp/bid/{{partner_id}}',
      available: [
        'syncUrl',
        {
          name: 'domain',
          replaceIn: {
            path: 'endpoint',
            pathAttribute: '{{yahoo_domain}}',
          },
          readFrom: {
            path: 'domain',
          },
        },
        {
          name: 'partnerId',
          replaceIn: {
            path: 'endpoint',
            pathAttribute: '{{partner_id}}',
          },
          readFrom: {
            path: 'partnerId',
          },
        },
        'tagid',
        'siteId',
      ],
      required: ['domain', 'partnerId', 'syncUrl'],
      config: {
        bidderKey: 'yahooDSP',
        bidderAbbr: 'YAHOODSP',
        bidderType: 'YahooDSP',
        bidder_eid_type: 'yahoo.com',
        cookieSyncTTL: 15,
        eids_feature: 1,
        supportUserSync: true,
        syncCallbackType: 'image',
        syncUrl: '',
        partnerId: '',
        domain: '',
        tagid: '',
        siteId: '',
      },
    },
    web: {
      replaceEndpoint: true,
      endpoint: 'https://{{yahoo_domain}}/dtp/bid/{{partner_id}}',
      available: [
        'syncUrl',
        {
          name: 'domain',
          replaceIn: {
            path: 'endpoint',
            pathAttribute: '{{yahoo_domain}}',
          },
          readFrom: {
            path: 'domain',
          },
        },
        {
          name: 'partnerId',
          replaceIn: {
            path: 'endpoint',
            pathAttribute: '{{partner_id}}',
          },
          readFrom: {
            path: 'partnerId',
          },
        },
        'tagid',
        'siteId',
      ],
      required: ['domain', 'partnerId', 'syncUrl'],
      config: {
        bidderKey: 'yahooDSP',
        bidderAbbr: 'YAHOODSP',
        bidderType: 'YahooDSP',
        bidder_eid_type: 'yahoo.com',
        cookieSyncTTL: 15,
        eids_feature: 1,
        supportUserSync: true,
        syncCallbackType: 'image',
        syncUrl: '',
        partnerId: '',
        domain: '',
        tagid: '',
        siteId: '',
      },
    },
  },
  {
    id: 35,
    name: 'Media.net',
    endpointMatcher: 'medianet',
    web: {
      replaceEndpoint: true,
      endpoint: 'https://exco-useast.media.net/rtb/pb/exco',
      available: [],
      required: [],
      config: {
        bidderKey: 'medianet'
      },
    },
    inApp: {
      replaceEndpoint: true,
      endpoint: 'https://exco-useast.media.net/rtb/pb/exco',
      available: [],
      required: [],
      config: {
        bidderKey: 'medianet'
      },
    },
  },
  {
    id: 36,
    name: 'Adagio',
    endpointMatcher: '4dex.io',
    web: {
      replaceEndpoint: true,
      endpoint: 'https://mp-las.4dex.io/ortb/{{PUBLISHER_ID}}',
      available: [
        {
          name: 'organizationId',
          path: 'publisherId',
          replaceIn: {
            path: 'endpoint',
            pathAttribute: '{{PUBLISHER_ID}}',
          },
        },
        'tagid',
        { name: 'pagetype', path: 'extensions.site.ext.pagetype' },
        { name: 'category', path: 'extensions.site.ext.category' },
        'schainStr',
      ],
      required: ['organizationId', 'tagid'],
      config: {
        bidderKey: 'adagio',
        publisherId: '',
        tagid: '',
        supportUserSync: true,
        syncCallbackType: 'iframe',
        syncUrl:
          'https://u-las.4dex.io/ortb/usync.html?publisher_id=[publisherId]&gdpr=[GDPR]&gdpr_consent=[GDPR_CONSENT]&us_privacy=[US_PRIVACY]&gpp=[GPP]&gpp_sid=[GPP_SID]&r=[SCHEME]%3A%2F%2Frtb.[SERV_DOMAIN]%2Fcookie_sync%3Fbid%3D[BIDDER_ID]%26srv%3D[SERV_DOMAIN]%26cuid%3D[CEDATO_USER_ID]%26uid%3D%7BUID%7D',
        extensions: {
          site: {
            ext: {
              pagetype: '',
              category: '',
            },
          },
        },
      },
    },
    inApp: {
      replaceEndpoint: true,
      endpoint: 'https://mp-las.4dex.io/ortb/{{PUBLISHER_ID}}',
      available: [
        {
          name: 'organizationId',
          path: 'publisherId',
          replaceIn: {
            path: 'endpoint',
            pathAttribute: '{{PUBLISHER_ID}}',
          },
        },
        'tagid',
        { name: 'pagetype', path: 'extensions.app.ext.pagetype' },
        { name: 'category', path: 'extensions.app.ext.category' },
        'displaymanager',
        'displaymanagerver',
        'schainStr',
      ],
      required: ['organizationId', 'tagid'],
      config: {
        bidderKey: 'adagio',
        publisherId: '',
        tagid: '',
        displaymanager: '',
        displaymanagerver: '',
        schainStr: '',
        extensions: {
          app: {
            ext: {
              pagetype: '',
              category: '',
            },
          },
        },
      },
    },
  },
];

export const WEB_ENV = 1;
export const APP_ENV = 2;
export const MAX_SCHAIN_NODES = 20;
export const MAX_SCHAIN_CSV_ROW_LENGTH = 400;
export const SCHAIN_CSV_HEADER_KEY_NAMES = ['key', 'bundle', 'domain'];
export const SCHAIN_CSV_HEADER_SCHAIN_NAMES = ['schain', 'schain_value', 'schain_val'];
